"use client";

import { c as _c } from "react/compiler-runtime";
import { Button, createTheme, defaultVariantColorsResolver, MantineProvider, VariantColorsResolver } from "@mantine/core";
import buttonStyles from "./buttonStyles.module.css";
const variantColorResolver: VariantColorsResolver = input => {
  const defaultResolvedColors = defaultVariantColorsResolver(input);

  // define custom variant colors for filled button
  if (input.variant === "primary") {
    return {
      background: "var(--color-action-primary-default)",
      hover: "var(--color-action-primary-hover)",
      color: "var(--color-text-inverse)",
      border: "none"
    };
  }
  return defaultResolvedColors;
};
const aopsMantineTheme = createTheme({
  fontFamily: "var(--body-md-typeface), sans-serif",
  headings: {
    fontFamily: "var(--display-primary), serif"
  },
  components: {
    Button: Button.extend({
      classNames: buttonStyles
    })
  },
  variantColorResolver
});

/**
 * MantineProvider that applies the AoPS (PACT) Design System theme to the app.
 * This will be used by each project's providers.tsx file which wraps the main app layout.
 * If an app needs custom theming, it can define another theme in their providers.tsx file and
 * put a new MantineProvider inside this one to override styles.
 *
 * // TODO: Replace the MantineProvider with the AopsThemeProvider in each project's providers.tsx file.
 */
export function AopsThemeProvider(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <MantineProvider theme={aopsMantineTheme}>{children}</MantineProvider>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}